export default __webpack_public_path__ + "assets/audio/ヒカリ証明論.1453df3f.m4a";